import React from 'react';
import { Search, X } from 'lucide-react';

interface SearchInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  showClear?: boolean;
  onAction?: () => void;
  actionLabel?: string;
  showAction?: boolean;
  containerClassName?: string;
  inputClassName?: string;
  iconClassName?: string;
  clearButtonClassName?: string;
  actionClassName?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  placeholder,
  onChange,
  onClear,
  showClear = false,
  onAction,
  actionLabel,
  showAction = false,
  containerClassName,
  inputClassName,
  iconClassName,
  clearButtonClassName,
  actionClassName,
}) => {
  return (
    <div className={containerClassName}>
      <Search size={18} className={iconClassName} />
      <input
        type="text"
        className={inputClassName}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {showClear && (
        <button
          className={clearButtonClassName}
          onClick={onClear}
          type="button"
        >
          <X size={16} />
        </button>
      )}
      {showAction && actionLabel && (
        <button
          className={actionClassName}
          onClick={onAction}
          type="button"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default SearchInput;
